var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { 
// eslint-disable-next-line no-restricted-imports
useQuery as originalUseQuery, } from '@tanstack/react-query';
import useWrappedNetworkFunction from '../error/useWrappedNetworkFunction.js';
/**
 * Wrapper for useQuery with error checking
 *
 * Refer to https://tanstack.com/query/latest/docs/react/reference/useQuery for usage
 *
 * @param queryKey see useQuery
 * @param queryFunction see useQuery
 */
const useQuery = (_a) => {
    var { queryKey, queryFn } = _a, rest = __rest(_a, ["queryKey", "queryFn"]);
    return originalUseQuery(Object.assign({ queryKey: queryKey, queryFn: useWrappedNetworkFunction(queryFn) }, rest));
};
export default useQuery;
//# sourceMappingURL=useQuery.js.map